// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".data-name[data-v-22fa98c8]{max-height:1.15em;min-height:1.15em}.title[data-v-22fa98c8]{-webkit-box-orient:vertical;-webkit-line-clamp:2;display:-webkit-box;max-height:2.3em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
